import { actionGenerator } from '../../utils/redux/actionGenerator';
import { ESortActionTypes, TSetSortOptionsType, TSetActiveSortType } from './types';
import { ESortType, ISort } from '../../types/sort';

export const setSortOptions: (payload: ISort[]) => TSetSortOptionsType = actionGenerator<
  ESortActionTypes.SetSortOptions,
  ISort[]
>(ESortActionTypes.SetSortOptions);

export const setActiveSort: (payload: ESortType) => TSetActiveSortType = actionGenerator<
  ESortActionTypes.SetActiveSort,
  ESortType
>(ESortActionTypes.SetActiveSort);
